
export class ClinicModel {
  id: number = 0;
  name: string = "";
  county?: string;
  address?: string;
  professionName?: string;
  imagePath?: string;

  favourite: boolean = false;
  order: string = "";

  constructor(init?: Partial<ClinicModel>) {
    if (init) Object.assign(this, init);
  }
}
